import { SFP_STEPS } from '../../steps';
import DeliveryPreferencesStep from '../../components/DeliveryPreferencesStep';

export default DeliveryPreferencesStep(SFP_STEPS);
